export default __webpack_public_path__ + "static/media/dpr-commingsoon.a26a2e2a.svg";